export enum RealEstateState {
  ERROR_SEND_TO_OFFER_API_FAILED = 'ERROR_SEND_TO_OFFER_API_FAILED',
  IN_OFFER_API_NEW = 'IN_OFFER_API_NEW',
  EDIT_FROM_OXM = 'EDIT_FROM_OXM',
  NEW_INSERTION = 'NEW_INSERTION',
  NOT_EXISTING = 'NOT_EXISTING',
  SENT_TO_OFFER_API = 'SENT_TO_OFFER_API',
}

type RealEstateStatusInOfferApiNew = {
  state: RealEstateState.IN_OFFER_API_NEW
  realEstateId: number
}
type RealEstateStatusInOfferApiNotExisting = {
  state: RealEstateState.NOT_EXISTING
}
type RealEstateDefaultStatus = {
  state: Exclude<RealEstateState, RealEstateState.IN_OFFER_API_NEW | RealEstateState.NOT_EXISTING>
  realEstateId: number
}

export type RealEstateStatus =
  RealEstateStatusInOfferApiNew | RealEstateStatusInOfferApiNotExisting | RealEstateDefaultStatus
